module.exports = __webpack_public_path__ + "images/emoji/birthday.c7666216b248db0f56ff.png";